// Computed state
export const COMPUTED_PRICING_POLICY_STATUS = {
  ACTIVE: 'ACTIVE',
  DISABLED: 'DISABLED',
  DRAFT: 'DRAFT',
  UPCOMING: 'UPCOMING',
  EXPIRED: 'EXPIRED',
} as const;
